module.exports = __webpack_public_path__ + "static/media/dashboard_manage_deck.7d604a2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/dashboard_manage_deck.jpg
// module id = 267
// module chunks = 0